import ContactsWrapper from 'src/components/Contacts/ContactsWrapper';

const ContactsPage = () => {
  return (
    <ContactsWrapper />
  );
};

export default ContactsPage;
